export const currentYearMonth = (): string => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

export const recentYearMonthRange = (
  count: number,
): { fromYearMonth: string; toYearMonth: string } => {
  const now = new Date();
  const from = new Date(now.getFullYear(), now.getMonth() - (count - 1), 1);
  return {
    fromYearMonth: `${from.getFullYear()}-${String(from.getMonth() + 1).padStart(2, '0')}`,
    toYearMonth: currentYearMonth(),
  };
};

export const extractYearMonthFromPeriodKey = (periodKey: string): string =>
  periodKey.replace(/^MONTH#/, '');
